import { Enumify } from 'enumify-ts';
class CommunicationType extends Enumify() {
    shortDescription;
    description;
    static APP = new CommunicationType('App', 'App Notification');
    static SMS = new CommunicationType('SMS', 'SMS Message');
    static EMAIL = new CommunicationType('Email', 'Email');
    static _ = CommunicationType._closeEnum();
    constructor(shortDescription, description) {
        super();
        this.shortDescription = shortDescription;
        this.description = description;
    }
}
export default CommunicationType;
